import React from 'react';
import Alert from 'components/UI/Alert';
import Button from 'components/UI/Button';

export function Component({ content, className }) {
  const { icon, text, button } = content;
  const { type, options } = button;
  return (
    <Alert
      icon={icon}
      content={text}
      className={className}
      Button={
        button && (
          <Button
            theme="secondary"
            tag={type.toLowerCase() === 'link' ? 'a' : 'button'}
            href={options.link}
          >
            {options.name}
          </Button>
        )
      }
    />
  );
}
